export default __webpack_public_path__ + "assets/icons/jp.6a03845f.svg";